import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Home, ShoppingCart, ListChecks, Package, Menu } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Copyright, NavList } from "./Sidebar";

const ITEMS = [
  { to: "/", label: "Home", icon: Home, id: "home" },
  { to: "/spesa", label: "Spesa", icon: ShoppingCart, id: "spesa" },
  { to: "/compiti", label: "Compiti", icon: ListChecks, id: "compiti" },
  { to: "/inventario", label: "Inventario", icon: Package, id: "inventario" },
];

export const BottomNav = () => {
  const [open, setOpen] = useState(false);
  const cls = ({ isActive }) => `flex flex-col items-center justify-center gap-1 h-16 text-xs font-medium ${isActive ? "text-primary" : "text-slate-600"}`;
  return (
    <>
      <nav data-testid="bottom-nav" className="lg:hidden fixed bottom-0 inset-x-0 z-30 bg-white border-t border-slate-200 grid grid-cols-5 pb-[env(safe-area-inset-bottom)]">
        {ITEMS.map(({ to, label, icon: Icon, id }) => (
          <NavLink key={id} to={to} end={to === "/"} data-testid={`bottom-nav-${id}`} className={cls}>
            <Icon className="h-6 w-6" />
            {label}
          </NavLink>
        ))}
        <button data-testid="bottom-nav-menu" onClick={() => setOpen(true)} className="flex flex-col items-center justify-center gap-1 h-16 text-xs font-medium text-slate-600">
          <Menu className="h-6 w-6" />
          Menu
        </button>
      </nav>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="left" className="w-[300px] overflow-y-auto">
          <SheetHeader><SheetTitle className="font-heading">Menu</SheetTitle></SheetHeader>
          <div className="mt-4"><NavList prefix="mobile" onNavigate={() => setOpen(false)} /></div>
          <Copyright className="mt-6 px-3" />
        </SheetContent>
      </Sheet>
    </>
  );
};
